import React from 'react';
import {connect} from 'react-redux';
import {Grid, Button, Dimmer, Loader, Header, Icon} from 'semantic-ui-react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {checkIfValuesAre} from 'common/utils';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Alert} from 'componentLibrary';
import ApiActions from 'go/actions/api';
import _ from 'lodash';
import {
  API_VENDOR_GET_SUCCESS,
  API_CREATE_UPDATE_ORG_SUCCESS,
  API_LINK_APP_TO_VENDOR_SUCCESS,
} from 'common/types';
import {SelectVendorModal} from './SelectVendorModal';

export const ErrorIndicator = ({errorType, children}) => {
  const color = errorType === 'warning' ? 'yellow' : 'red';
  return (
    <React.Fragment>
      <Icon name="exclamation circle" size="large" color={color} /> {children}
    </React.Fragment>
  );
};

export const getRelevantAppOrgInfo = (orgInfo) => {
  const dunsPlusFour = _.get(orgInfo, 'dunsPlus4') || '';
  return {
    duns: _.get(orgInfo, 'duns') + dunsPlusFour,
    legalName: _.get(orgInfo, 'legalName'),
    ein: _.get(orgInfo, 'ein'),
    zip: _.get(orgInfo, 'businessAddress.zip'),
    bankAccount: _.get(orgInfo, 'businessBankAccount.accountNumber'),
    bankRouting: _.get(orgInfo, 'businessBankAccount.routingNumber'),
  };
};

export const getRelevantOrgInfo = (orgData, duns) => {
  return {
    duns: duns,
    legalName: _.get(orgData, 'organization.legalName'),
    ein: _.get(orgData, 'organization.ein'),
    zip: _.get(orgData, 'organization.physicalAddress.zip'),
    bankAccount: _.get(orgData, 'bankList[0].accountNumber'),
    bankRouting: _.get(orgData, 'bankList[0].routingNumber'),
  };
};

export const getRelevantVendorInfo = (vendorData, duns) => {
  return _.map(vendorData, (vendor) => ({
    duns: duns,
    vendorId: _.get(vendor, 'vendorId'),
    legalName: _.get(vendor, 'legalName'),
    ein: _.get(vendor, 'ein'),
    zip: _.get(vendor, 'zipcode'),
    bankAccount: _.get(vendor, 'bankInfoList[0].accountNumber'),
    bankRouting: _.get(vendor, 'bankInfoList[0].routingNumber'),
    vendorIfmisFlag: _.get(vendor, 'vendorIfmisFlag'),
    vendorCategoryCode: _.get(vendor, 'vendorCategoryCode'),
  }));
};

export class LinkApplicationToVendor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputtedDuns: '',
      lastSearchedDuns: '',
      invalidDunsError: false,
      loading: true,
      organization: {},
      vendors: [],
      selectedVendor: this.props.linkedVendorId,
      appData: {},
      chosenOrgId: '',
      networkError: false,
      showVendorList: false,
      linkingOrg: false,
      fetchingVendorData: false,
    };
  }

  componentDidMount = () => {
    if (this.props.appOrgInfo !== undefined) {
      this.initializeWithApplicationData(this.props.appOrgInfo);
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (!_.isEqual(prevProps.appOrgInfo, this.props.appOrgInfo)) {
      this.initializeWithApplicationData(this.props.appOrgInfo);
    }
  };

  initializeWithApplicationData = (appOrgInfo) => {
    const appData = getRelevantAppOrgInfo(appOrgInfo);
    const duns = this.props.linkedDuns || appData.duns;
    this.setState(
      {
        inputtedDuns: duns,
        appData,
      },
      this.handleDunsSearch(duns)
    );
  };

  handleDunsChange = (value) => {
    const numberValue = !checkIfValuesAre([null, '', undefined], value)
      ? _.toNumber(value)
      : value;
    if (!_.isNaN(numberValue)) {
      this.setState({
        inputtedDuns: value,
      });
    }
  };

  handleDunsSearch = (duns) => {
    const dunsLength = _.size(duns);
    const {linkedVendorId, token} = this.props;
    if (dunsLength === 9 || dunsLength === 13) {
      const orgCall = this.props.createUpdateOrg(token, duns);
      const vendorCall = this.props.getVendorData(token, duns);
      Promise.all([orgCall, vendorCall])
        .then((values) => {
          const orgRes = values[0];
          const vendorRes = values[1];
          const orgSuccess = orgRes.type === API_CREATE_UPDATE_ORG_SUCCESS;
          const vendorSuccess =
            vendorRes.type === API_VENDOR_GET_SUCCESS &&
            _.get(vendorRes, 'payload.vendorMatched', true);
          const organization = orgSuccess ? getRelevantOrgInfo(orgRes.payload, duns) : {};
          const vendors = vendorSuccess
            ? getRelevantVendorInfo(vendorRes.payload, duns)
            : [];
          const numVendors = _.size(vendors);
          let newState = {
            lastSearchedDuns: duns,
            invalidDunsError: false,
            chosenOrgId: orgSuccess
              ? _.get(orgRes, 'payload.organization.organizationId')
              : null,
            organization,
            vendors,
            networkError: !orgSuccess,
            loading: false,
            fetchingVendorData: false,
          };
          if (numVendors === 1) {
            newState.selectedVendor = _.get(vendors, [0, 'vendorId']);
          } else if (numVendors) {
            const linked = _.find(
              vendors,
              (vendor) => vendor.vendorId === linkedVendorId
            );
            if (linked) {
              newState.selectedVendor = linkedVendorId;
            }
          }
          this.setState(newState);
        })
        .catch((err) => {
          this.setState({
            networkError: true,
            organization: {},
            vendors: [],
            chosenOrgId: null,
            loading: false,
            fetchingVendorData: false,
          });
        });
      this.setState({
        fetchingVendorData: true,
        selectedVendor: false,
      });
    } else {
      this.setState({
        invalidDunsError: true,
        loading: false,
      });
    }
  };

  closeVendorListModal = () => this.setState({showVendorList: false});

  selectVendor = (vendorId) => {
    this.setState({
      showVendorList: false,
      selectedVendor: vendorId,
    });
    // TODO, enhance by allowing the selected vendor to be saved across sessions (without linking)
  };

  linkOrg = () => {
    this.props
      .linkApplicationToOrg(
        this.props.token,
        this.props.grantId,
        this.state.chosenOrgId,
        this.state.selectedVendor
      )
      .then((res) => {
        if (res.type === API_LINK_APP_TO_VENDOR_SUCCESS) {
          let orgDataForContext = {
            ...this.state.organization,
            organizationId: this.state.chosenOrgId, // may not need this there
          };
          // update within session for reviewPanel specifically, backend has already done linking for award rec in db
          this.props.saveEntitySessionData('context.organization', orgDataForContext);
          this.props.saveEntitySessionData(
            'context.awardRecommendation.organizationId',
            res.payload.organizationId
          );
          this.props.saveEntitySessionData(
            'context.awardRecommendation.payload.vendorId',
            this.state.selectedVendor
          );
          this.setState({
            linkingOrg: false,
          });
          return res;
        } else {
          console.log('failed to link application to vendor'); // TODO
          return Promise.reject(res.type);
        }
      })
      .catch((err) => {
        console.log('failed to link application to vendor');
        this.setState({
          networkError: err,
          linkingOrg: false,
        });
        return err;
      });
    this.setState({
      linkingOrg: true,
    });
  };

  errorAlert(vendors, vendorSelected) {
    const numVendors = _.size(vendors);
    const multipleText =
      'There are multiple vendor records in IFMIS associated with this DUNS number. Please select the correct vendor record to be associated with this grant.';
    const notFoundText =
      'There are no vendor records in IFMIS for this DUNS number. Please contact OCFO to resolve.';
    if (numVendors !== 1 && !vendorSelected) {
      return (
        <Alert
          type={numVendors ? 'warning' : 'error'}
          header={numVendors ? multipleText : notFoundText}
        />
      );
    }
    return null;
  }

  selectVendorLink() {
    return (
      <span>
        <Icon name="exclamation circle" size="large" color="yellow" />
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            this.setState({showVendorList: true});
          }}
        >
          Select vendor
        </a>
      </span>
    );
  }

  render() {
    const {organization, vendors, appData} = this.state;

    if (this.state.loading) {
      return (
        <div className="padding-top padding-bottom">
          <Dimmer active inverted>
            <Loader inverted />
          </Dimmer>
        </div>
      );
    }

    let alertContent, alertHeader;
    if (this.props.linkedDuns && this.props.linkedVendorId) {
      alertContent = `The application is for the organization with DUNS: ${this.props.linkedDuns}. The table below shows the details from SAM.gov and IFMIS for this organization. If there is a discrepancy, \
      this may be because of outdated SAM.gov information, outdated IFMIS information,\
       recipient error in organization selection, or a combination of all three. If information has been updated in SAM.gov or IFMIS, it will automatically be updated in this table when you reload the page.`;
      alertHeader = 'The application has been linked to a vendor';
    } else {
      alertContent =
        'The information does not match between SAM.gov and IFMIS. Please validate if either of them is the correct information, then contact the user or OCFO to get the incorrect data to be changed. \
        If information has been updated in SAM.gov or IFMIS, it will automatically be updated \
        in this table when you reload the page. If there are multiple IFMIS records associated with this DUNS, you must select a single record before linking the application to a vendor.';
      alertHeader = 'FEMA GO has detected a discrepancy';
    }
    const selectedAlert = `You have selected the IFMIS vendor record with vendor ID ${this.state.selectedVendor}. \
    This vendor record will not be associated with this grant until you click on the "Link application to vendor" button.`;

    const chosenVendor = _.find(
      this.state.vendors,
      (vendor) => vendor.vendorId === this.state.selectedVendor
    );
    const numVendorsFound = _.size(vendors);

    return (
      <React.Fragment>
        <SelectVendorModal
          active={this.state.showVendorList}
          vendors={this.state.vendors}
          cancelAction={this.closeVendorListModal}
          selectAction={this.selectVendor}
          selectedVendor={this.state.selectedVendor}
        />
        <Alert type="info" content={alertContent} header={alertHeader} />
        {this.errorAlert(this.state.vendors, this.state.selectedVendor)}
        {this.state.selectedVendor && numVendorsFound > 1 ? (
          <Alert type="info" header={selectedAlert} />
        ) : null}
        <Header as="h2">Vendor details</Header>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <FemaGoTable
                basic={true}
                columns={4}
                type="entry"
                celled={false}
                handleSubmit={() => this.handleDunsSearch(this.state.inputtedDuns)}
              >
                <FemaGoTable.Header>
                  <FemaGoTable.Row>
                    <FemaGoTable.HeaderCell />
                    <FemaGoTable.HeaderCell>Sam.gov</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>IFMIS</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>
                      {this.props.grantNumber}
                    </FemaGoTable.HeaderCell>
                  </FemaGoTable.Row>
                </FemaGoTable.Header>
                <FemaGoTable.Body>
                  <FemaGoTable.Row>
                    <FemaGoTable.TextCell>
                      <label htmlFor="search-by-duns">Duns</label>
                    </FemaGoTable.TextCell>
                    <FemaGoTable.ActionCell
                      id={'search-by-duns'}
                      name="duns"
                      value={this.state.inputtedDuns}
                      iconName="search"
                      handleChange={(e, res) => this.handleDunsChange(e.target.value)}
                      handleBlur={() => {}}
                      title="DUNS number"
                      displayError={this.state.invalidDunsError}
                    />
                    {numVendorsFound !== 1 ? (
                      <FemaGoTable.TextCell
                        emphasis={numVendorsFound ? 'warning' : 'error'}
                        verticalAlign="middle"
                      >
                        <ErrorIndicator
                          errorType={numVendorsFound === 0 ? 'error' : 'warning'}
                        >
                          {_.get(chosenVendor, 'duns', 'ERROR')}
                        </ErrorIndicator>
                      </FemaGoTable.TextCell>
                    ) : (
                      <FemaGoTable.TextCell>
                        {_.get(chosenVendor, 'duns', 'ERROR')}
                      </FemaGoTable.TextCell>
                    )}
                    <FemaGoTable.TextCell>{appData.duns}</FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                  <FemaGoTable.Row>
                    <FemaGoTable.TextCell>IFMIS Vendor ID</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>-</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {_.get(chosenVendor, 'vendorId', 'ERROR')}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>-</FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                  <FemaGoTable.Row>
                    <FemaGoTable.TextCell>IFMIS Status</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>-</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {_.get(chosenVendor, 'vendorIfmisFlag', 'ERROR')}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>-</FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                  <FemaGoTable.Row>
                    <FemaGoTable.TextCell>IFMIS Category</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>-</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {_.get(chosenVendor, 'vendorCategoryCode', 'ERROR')}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>-</FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                  <FemaGoTable.Row>
                    <FemaGoTable.TextCell>Legal name</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {organization.legalName || 'ERROR'}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {_.get(chosenVendor, 'legalName', 'ERROR')}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>{appData.legalName}</FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                  <FemaGoTable.Row>
                    <FemaGoTable.TextCell>EIN</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {organization.ein || 'ERROR'}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {_.get(chosenVendor, 'ein', 'ERROR')}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>{appData.ein}</FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                  <FemaGoTable.Row>
                    <FemaGoTable.TextCell>Bank account</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {organization.bankAccount || 'ERROR'}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {_.get(chosenVendor, 'bankAccount', 'ERROR')}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>{appData.bankAccount}</FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                  <FemaGoTable.Row>
                    <FemaGoTable.TextCell>Bank routing</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {organization.bankRouting || 'ERROR'}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {_.get(chosenVendor, 'bankRouting', 'ERROR')}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>{appData.bankRouting}</FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                  <FemaGoTable.Row>
                    <FemaGoTable.TextCell>Zip code</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {organization.zip || 'ERROR'}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {_.get(chosenVendor, 'zip', 'ERROR')}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>{appData.zip}</FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                  {numVendorsFound !== 0 && (
                    <FemaGoTable.Row>
                      <FemaGoTable.TextCell />
                      <FemaGoTable.TextCell>
                        {this.state.fetchingVendorData ? (
                          <Loader active inline size="tiny" />
                        ) : (
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.handleDunsSearch(this.state.lastSearchedDuns);
                            }}
                          >
                            Refresh vendor data
                          </a>
                        )}
                      </FemaGoTable.TextCell>
                      {numVendorsFound > 1 ? (
                        <FemaGoTable.TextCell emphasis="warning">
                          {this.selectVendorLink()}
                        </FemaGoTable.TextCell>
                      ) : (
                        <FemaGoTable.TextCell />
                      )}
                      <FemaGoTable.TextCell />
                    </FemaGoTable.Row>
                  )}
                </FemaGoTable.Body>
              </FemaGoTable>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Button
                disabled={
                  !_.get(this.state.organization, 'legalName') === undefined ||
                  !this.state.selectedVendor ||
                  this.state.networkError
                }
                floated="right"
                primary
                onClick={() => this.linkOrg()}
                loading={this.state.linkingOrg}
              >
                Link application to vendor
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => ({
  token: state.auth.token,
});

export const mapDispatchToProps = (dispatch) => ({
  getVendorData: (token, duns) => {
    const action = ApiActions.vendor.getVendorInfoForDuns(token, duns);
    const res = dispatch(action);
    return res;
  },
  createUpdateOrg: (token, duns) => {
    const action = ApiActions.organization.createUpdateOrg(token, duns);
    const res = dispatch(action);
    return res;
  },
  linkApplicationToOrg: (token, grantNumber, orgId, vendorId) => {
    const action = ApiActions.organization.linkApplicationToVendor(
      token,
      grantNumber,
      orgId,
      vendorId
    );
    const res = dispatch(action);
    return res;
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectDynamic(LinkApplicationToVendor));
